// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// css样式还是需要全部引入
import 'element-ui/lib/theme-chalk/index.css'
import view from './view/index'
import axios from 'axios'
// 引入echarts
import echarts from 'echarts'
import "echarts-liquidfill";
import screenfull from 'screenfull'
import Blob from '@/Excel/Blob'
import Export2Excel from '@/Excel/Export2Excel.js'
Vue.prototype.$echarts = echarts
Vue.use(view)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js